import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { NbWindowService, NbWindowRef } from "@nebular/theme";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { AccountService } from "src/app/dashboard/services/account.service";
import { GeneralService } from "src/app/dashboard/services/general.service";
import { AccountsList } from "src/app/dashboard/model/interface.model";

import Swal from "sweetalert2";

@Component({
  selector: "app-demo",
  templateUrl: "./demo.component.html",
  styleUrls: ["./demo.component.css"],
})
export class DemoComponent implements OnInit {
  accountNameForm: FormGroup;
  tradePasswordForm: FormGroup;
  investorPasswordForm: FormGroup;
  phonePasswordForm: FormGroup;
  leverageForm: FormGroup;
  openDemoAccountForm: FormGroup;

  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("tradePasswordTemplate")
  tradePasswordTemplate: TemplateRef<any>;
  @ViewChild("investorPasswordTemplate")
  investorPasswordTemplate: TemplateRef<any>;
  @ViewChild("phonePasswordTemplate")
  phonePasswordTemplate: TemplateRef<any>;
  @ViewChild("leverageTemplate")
  leverageTemplate: TemplateRef<any>;

  password_type_toggle: boolean = true;
  investor_password_type_toggle: boolean = true;

  //Trade Password Template
  tradePasswordOnFocus: boolean = false;
  tradePasswordStrengthStep1: boolean = false;
  tradePasswordStrengthStep2: boolean = false;
  isTradePasswordMatch: boolean = false;

  //Investor Password Template
  investorPasswordOnFocus: boolean = false;
  investorPasswordStrengthStep1: boolean = false;
  investorPasswordStrengthStep2: boolean = false;
  isInvestorPasswordMatch: boolean = false;

  //Loading Spinner param
  isTradePasswordLoading: boolean = false;
  isAccountNameLoading: boolean = false;
  isPhonePasswordLoading: boolean = false;
  isLeverageLoading: boolean = false;
  isInvestorPasswordLoading: boolean = false;
  isAccountOpenLoading: boolean = false;

  leverageList: number[] = null;
  modalLeverageList: number[] = null;
  depositList: number[] = null;
  accountTypeList: { type: string; leverages: number[] }[] = null;

  accounts: AccountsList[] = null;

  constructor(
    private windowService: NbWindowService,
    private account: AccountService,
    private general: GeneralService
  ) {}

  ngOnInit() {
    this.accountNameForm = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      login: new FormControl(null),
    });

    this.tradePasswordForm = new FormGroup({
      tradePassword: new FormControl(null, [Validators.required]),
      tradePasswordRepeat: new FormControl(null, [Validators.required]),
      login: new FormControl(null),
    });

    this.investorPasswordForm = new FormGroup({
      investorPassword: new FormControl(null, [Validators.required]),
      investorPasswordRepeat: new FormControl(null, [Validators.required]),
      login: new FormControl(null),
    });

    this.phonePasswordForm = new FormGroup({
      password: new FormControl(null, [Validators.required]),
      login: new FormControl(null),
    });

    this.leverageForm = new FormGroup({
      leverage: new FormControl(null, [Validators.required]),
      login: new FormControl(null),
    });

    this.openDemoAccountForm = new FormGroup({
      type: new FormControl(null, [Validators.required]),
      leverage: new FormControl(null, [Validators.required]),
      deposit: new FormControl(null, [Validators.required]),
    });

    this.tradePasswordForm
      .get("tradePassword")
      .valueChanges.subscribe((value: string) => {
        if (value === null) {
          value = "";
        }
        this.tradePasswordStrengthStep1 = this.general.checkPasswordLength(
          value
        );
        this.tradePasswordStrengthStep2 = this.general.checkPasswordAlphaNum(
          value
        );
      });

    this.investorPasswordForm
      .get("investorPassword")
      .valueChanges.subscribe((value: string) => {
        if (value === null) {
          value = "";
        }
        this.investorPasswordStrengthStep1 = this.general.checkPasswordLength(
          value
        );
        this.investorPasswordStrengthStep2 = this.general.checkPasswordAlphaNum(
          value
        );
      });

    this.tradePasswordForm
      .get("tradePasswordRepeat")
      .valueChanges.subscribe((value: string) => {
        if (value === null) {
          value = "";
        }
        this.isTradePasswordMatch = this.general.checkPasswordMatch(
          value,
          this.tradePasswordForm.get("tradePassword").value
        );
      });

    this.tradePasswordForm
      .get("tradePassword")
      .valueChanges.subscribe((value: string) => {
        if (value === null) {
          value = "";
        }
        this.isTradePasswordMatch = this.general.checkPasswordMatch(
          value,
          this.tradePasswordForm.get("tradePasswordRepeat").value
        );
      });

    this.investorPasswordForm
      .get("investorPasswordRepeat")
      .valueChanges.subscribe((value: string) => {
        if (value === null) {
          value = "";
        }
        this.isInvestorPasswordMatch = this.general.checkPasswordMatch(
          value,
          this.investorPasswordForm.get("investorPassword").value
        );
      });

    this.investorPasswordForm
      .get("investorPassword")
      .valueChanges.subscribe((value: string) => {
        if (value === null) {
          value = "";
        }
        this.isInvestorPasswordMatch = this.general.checkPasswordMatch(
          value,
          this.investorPasswordForm.get("investorPasswordRepeat").value
        );
      });

    this.openDemoAccountForm
      .get("type")
      .valueChanges.subscribe(
        (value: { type: string; leverages: number[] }) => {
          this.leverageList = value.leverages;
        }
      );

    this.getAccountTypes();
    this.getDemoAccounts();
  }

  getAccountTypes() {
    this.account.getAccountTypeDemo().subscribe((response) => {
      if (response.data) {
        this.accountTypeList = response.data.type;
        this.depositList = response.data.deposit;
      }
    });
  }

  getDemoAccounts() {
    this.account.getDemoAccounts().subscribe((response) => {
      this.accounts = response.data;
    });
  }

  nameUpdateTempWindow: NbWindowRef;
  nameUpdateWindow(account: AccountsList) {
    this.nameUpdateTempWindow = this.windowService.open(this.nameTemplate, {
      title: "Change trade account name",
      closeOnBackdropClick: false,
      closeOnEsc: false,
    });

    this.accountNameForm.setValue({
      name: account.name,
      login: account.login,
    });
  }

  updateDemoAccountName() {
    this.isAccountNameLoading = true;
    let formData: { name: string; login: number; type: string } = {
      name: this.accountNameForm.value.name,
      login: this.accountNameForm.value.login,
      type: "demo",
    };

    this.account.updateTradeAccountName(formData).subscribe(
      (response) => {
        this.isAccountNameLoading = false;
        if (response.request_status) {
          this.nameUpdateTempWindow.close();
          this.getDemoAccounts();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.isAccountNameLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  tradePasswordUpdateTempWindow: NbWindowRef;
  passwordUpdateWindow(account: AccountsList) {
    this.tradePasswordUpdateTempWindow = this.windowService.open(
      this.tradePasswordTemplate,
      {
        title: "Change trade password",
        closeOnBackdropClick: false,
        closeOnEsc: false,
      }
    );
    this.tradePasswordForm.reset();
    this.tradePasswordForm.patchValue({
      login: account.login,
      tradePassword: "",
      tradePasswordRepeat: "",
    });
  }

  updateTradePassword() {
    this.isTradePasswordLoading = true;
    let formData: {
      password: string;
      login: number;
      type: string;
      password_type: number;
    } = {
      password: this.tradePasswordForm.value.tradePasswordRepeat,
      login: this.tradePasswordForm.value.login,
      type: "demo",
      password_type: 1,
    };

    this.account.updateTradeAccountPassword(formData).subscribe(
      (response) => {
        this.isTradePasswordLoading = false;
        if (response.request_status) {
          this.tradePasswordUpdateTempWindow.close();
          this.getDemoAccounts();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.isTradePasswordLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  investorPasswordUpdateTempWindow: NbWindowRef;
  investorPasswordUpdateWindow(account: AccountsList) {
    this.investorPasswordUpdateTempWindow = this.windowService.open(
      this.investorPasswordTemplate,
      {
        title: "Change investor password",
        closeOnBackdropClick: false,
        closeOnEsc: false,
      }
    );
    this.investorPasswordForm.reset();
    this.investorPasswordForm.patchValue({
      login: account.login,
      investorPassword: "",
      investorPasswordRepeat: "",
    });
  }

  updateInvestorPassword() {
    this.isInvestorPasswordLoading = true;
    let formData: {
      password: string;
      login: number;
      type: string;
      password_type: number;
    } = {
      password: this.investorPasswordForm.value.investorPasswordRepeat,
      login: this.investorPasswordForm.value.login,
      type: "demo",
      password_type: 2,
    };

    this.account.updateTradeAccountPassword(formData).subscribe(
      (response) => {
        this.isInvestorPasswordLoading = false;
        if (response.request_status) {
          this.investorPasswordUpdateTempWindow.close();
          this.getDemoAccounts();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.isInvestorPasswordLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  phonePasswordUpdateTempWindow: NbWindowRef;
  phonePasswordUpdateWindow(account: AccountsList) {
    this.phonePasswordUpdateTempWindow = this.windowService.open(
      this.phonePasswordTemplate,
      {
        title: "Change phone password",
        closeOnBackdropClick: false,
        closeOnEsc: false,
      }
    );
    this.phonePasswordForm.reset();
    this.phonePasswordForm.setValue({
      login: account.login,
      password: account.phone_password,
    });
  }

  updatePhonePassword() {
    this.isPhonePasswordLoading = true;

    let formData: {
      password: string;
      login: number;
      type: string;
      password_type: number;
    } = {
      password: this.phonePasswordForm.value.password,
      login: this.phonePasswordForm.value.login,
      type: "demo",
      password_type: 3,
    };

    this.account.updateTradeAccountPassword(formData).subscribe(
      (response) => {
        this.isPhonePasswordLoading = false;
        if (response.request_status) {
          this.phonePasswordUpdateTempWindow.close();
          this.getDemoAccounts();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.isPhonePasswordLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  leverageUpdateTempWindow: NbWindowRef;
  leverageUpdateWindow(account: AccountsList) {
    this.leverageUpdateTempWindow = this.windowService.open(
      this.leverageTemplate,
      {
        title: "Change leverage",
        closeOnBackdropClick: false,
        closeOnEsc: false,
      }
    );
    this.leverageForm.patchValue({
      login: account.login,
      leverage: account.leverage,
    });

    this.accountTypeList.forEach((value) => {
      if (value.type.toLowerCase() === account.type.toLowerCase()) {
        this.modalLeverageList = value.leverages;
      }
    }, this);
  }

  updateLeverage() {
    this.isLeverageLoading = true;
    let formData: {
      leverage: number;
      login: number;
      type: string;
    } = {
      leverage: this.leverageForm.value.leverage,
      login: this.leverageForm.value.login,
      type: "demo",
    };

    this.account.updateTradeAccountLeverage(formData).subscribe(
      (response) => {
        this.isLeverageLoading = false;
        if (response.request_status) {
          this.leverageUpdateTempWindow.close();
          this.getDemoAccounts();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.isLeverageLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  togglePasswordShow() {
    this.password_type_toggle = !this.password_type_toggle;
  }

  toggleInvestorPasswordShow() {
    this.investor_password_type_toggle = !this.investor_password_type_toggle;
  }

  createDemoAccount() {
    let formData: { type: string; leverage: number; deposit: number } = {
      type: this.openDemoAccountForm.value.type.type,
      leverage: parseInt(this.openDemoAccountForm.value.leverage),
      deposit: this.openDemoAccountForm.value.deposit,
    };
    this.isAccountOpenLoading = true;
    this.account.createDemoAccount(formData).subscribe(
      (response) => {
        if (response.request_status) {
          Swal.fire(
            "Login: " + response.data.login,
            "account created, check your mail for account credentials",
            "success"
          );
          this.getDemoAccounts();
        } else {
          Swal.fire("", response.error_message, "warning");
        }
        this.isAccountOpenLoading = false;
        this.openDemoAccountForm.reset();
      },
      (error) => {
        this.isAccountOpenLoading = false;
        Swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }
}
